






























import Vue from 'vue';
import { SimulatorState } from '@/simulator';

export default Vue.extend({
	props: {
		tooltip: String,
		hidePlayback: Boolean
	},
	computed: {
		currentTick: SimulatorState.currentTick,
		running: SimulatorState.running,
		paused: SimulatorState.paused,
		delay: SimulatorState.delay,
		errors: SimulatorState.errors
	},
	methods: {
		run: () => SimulatorState.start(),
		stop: () => SimulatorState.stop(),

		pause: () => SimulatorState.pause(),
		resume: () => SimulatorState.resume(),

		stepBack: () => SimulatorState.stepBack(),
		stepForward: () => SimulatorState.stepForward(),

		reset: () => SimulatorState.reset(),
		setDelay: function (delay: number) {
			SimulatorState.setDelay(1000 / delay)
		},

		tip(text?: string) {
			this.$emit('update:tooltip', text);
		}
	}
});
